<template>
	<div>
		<Calendar
			:attributes="attributes"
			:min-date="minDate"
			:max-date="maxDate"
			ref="calendar"
			@dayclick="onDayClick"
		/>
	</div>
</template>

<script>
import Calendar from 'v-calendar/lib/components/calendar.umd'
import {DateTime} from "luxon";

export default {

	components: {
		Calendar,
	},

	props: {
		value: {
			type: Object,
			required: false
		},
		forceMinDate: {
			type: Date,
			required: false,
		},
		forceMaxDate: {
			type: Date,
			required: false,
		},
		yearsInFuture: {
			type: Number,
			required: false,
		}
	},

	mounted ()
	{
		if (this.chosenDate)
		{
			this.$refs.calendar.focusDate(this.chosenDate);
		}
	},

	data ()
	{
		let chosenDate = undefined;

		if (this.value)
		{
			chosenDate = DateTime
				.fromObject(this.value)
				.toISO();
		}

		return {
			chosenDate,
		};
	},

	computed: {
		attributes ()
		{
			return this.chosenDate
				? [ { dates: this.chosenDate, highlight: true } ]
				: [];
		},
		minDate ()
		{
			return this.forceMinDate;
		},
		maxDate ()
		{
			if (this.forceMaxDate)
			{
				return this.forceMaxDate;
			}

			if (this.yearsInFuture)
			{
				return DateTime
					.now()
					.plus({ years: this.yearsInFuture })
					.toJSDate();
			}

			return undefined;
		}
	},

	methods: {
		onDayClick (data)
		{
			if (data.isDisabled)
			{
				return;
			}

			this.chosenDate = data.date;

			this.$emit('input', this.chosenDate
				? {
					day: data.day,
					month: data.month,
					year: data.year,
				}
				: undefined
			);
		}
	},

	watch: {
		value (v)
		{
			if (v)
			{
				this.chosenDate = DateTime
					.fromObject(v)
					.toISO();
			}
		}
	}
}
</script>
